// eslint-disable-next-line no-shadow
export enum OptionType {
  school = 'School',
  department = 'Department',
  institution = 'Institution',
  collaboratingInstitution = 'CollaboratingInstitution',
  typeOfResearch = 'TypeOfResearch',
  sponsorType = 'SponsorType',
  typeOfReview = 'TypeOfReview',
  status = 'Status',
  reviewCycle = 'ReviewCycle',
  nTRIRBCoordinator = 'NTRIRBCoordinator',
  investigator = 'Investigator',
  fundingAgency = 'FundingAgency',
  natureOfResearch = 'NatureOfResearch',
  sponsoredClinicalTrial = 'SponsoredClinicalTrial', //Sponsored Clinical Trials
  irbofRecord='IrbofRecord',
}
